/**
 * @generated SignedSource<<f0499cad3894a5e3f81c4c024825f66e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupDescriptionDialog_group$data = {
  readonly description: string;
  readonly id: string;
  readonly " $fragmentType": "GroupDescriptionDialog_group";
};
export type GroupDescriptionDialog_group$key = {
  readonly " $data"?: GroupDescriptionDialog_group$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupDescriptionDialog_group">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupDescriptionDialog_group",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Group",
  "abstractKey": null
};

(node as any).hash = "198260ea69c63a745afb3d0d4abbe2ca";

export default node;
